"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondsToResetDefaults = exports.SuccessActionTypes = void 0;
var SuccessActionTypes;
(function (SuccessActionTypes) {
    SuccessActionTypes["SHOW_MESSAGE"] = "SHOW_MESSAGE";
    SuccessActionTypes["LINK"] = "LINK";
    SuccessActionTypes["DOWNLOAD_DOCUMENT"] = "DOWNLOAD_DOCUMENT";
    SuccessActionTypes["EXTERNAL_LINK"] = "EXTERNAL_LINK";
})(SuccessActionTypes = exports.SuccessActionTypes || (exports.SuccessActionTypes = {}));
var SecondsToResetDefaults;
(function (SecondsToResetDefaults) {
    SecondsToResetDefaults[SecondsToResetDefaults["MIN"] = 5] = "MIN";
    SecondsToResetDefaults[SecondsToResetDefaults["MAX"] = 10] = "MAX";
    SecondsToResetDefaults[SecondsToResetDefaults["DEFAULT"] = 8] = "DEFAULT";
})(SecondsToResetDefaults = exports.SecondsToResetDefaults || (exports.SecondsToResetDefaults = {}));
//# sourceMappingURL=success-settings.js.map